export default __webpack_public_path__ + "static/media/c002-whatsapp-01-en.454bfd32.png";